export function replacePath(fullpath) {
	const path = fullpath.replace(/^.*\/\/[^/]+/, "")

	return path
}
